
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaches/[slugCoach]/series/[slugSeries]",
      function () {
        return require("private-next-pages/coaches/[slugCoach]/series/[slugSeries].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaches/[slugCoach]/series/[slugSeries]"])
      });
    }
  